import { create } from "zustand"

const useUserStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('userData')) || null,
  setUser: (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData))
    set({ user: userData })
  },
  clearUser: () => {
    localStorage.removeItem('userData')
    set({ user: null })
  }
}))

export default useUserStore
